import { render } from "./editDoctor.vue?vue&type=template&id=155689e9&scoped=true"
import script from "./editDoctor.vue?vue&type=script&lang=js"
export * from "./editDoctor.vue?vue&type=script&lang=js"

import "./editDoctor.vue?vue&type=style&index=0&id=155689e9&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155689e9"]])

export default __exports__